<template>
  <div class="information-message-box">
    <MessageBoxCommon
      :showMessageBox.sync="isSetShowMessageBox"
      :title="
        $t('home.walletConnect.acceptInvitationInformationMessageBox.title')
      "
    >
      <template #top>
        <TradeCountdown @close="close" />

        <div class="box-loading flex-center">
          <i class="icon icon-loading roll"></i>
          <p>
            {{
              $t(
                "home.walletConnect.acceptInvitationInformationMessageBox.pleaseText"
              )
            }}
          </p>
        </div>
      </template>
      <template #content>
        <div class="box-message-content">
          <p>
            {{
              $t(
                "home.walletConnect.acceptInvitationInformationMessageBox.youshouldText"
              )
            }}
          </p>
          <p class="text-max text-invite-address">{{ inviteAddress }}</p>
          <p>
            {{
              $t(
                "home.walletConnect.acceptInvitationInformationMessageBox.followText"
              )
            }}
          </p>
        </div>
      </template>
    </MessageBoxCommon>
  </div>
</template>
<script>
import MessageBoxCommon from "@/components/Common/messageBox";
import TradeCountdown from "@/components/Common/tradeCountdown.vue";

export default {
  name: "informationMessageBox",
  props: {
    showMessageBox: {
      type: Boolean,
      default: false,
    },
    inviteAddress: String,
  },
  components: { MessageBoxCommon, TradeCountdown },
  computed: {
    isSetShowMessageBox: {
      get() {
        return this.showMessageBox;
      },
      set(val) {
        this.$emit("update:showMessageBox", val);
      },
    },
  },
  methods: {
    close() {
      this.$emit("update:showMessageBox", false);
    },
  },
};
</script>
<style lang="scss" scoped>
.information-message-box {
  .text-amount {
    text-align: center;
    margin-bottom: 12px;
  }
  .gas-fee {
    text-align: center;

    .text-amount {
      margin-left: 6px;
      margin-right: 2px;
    }
  }
  .chain-amount {
    margin-bottom: 24px;
    h3 {
      &:last-child {
        margin-left: 8px;
      }
    }
  }

  .chain-kljt-box {
    margin-left: 28px;
    margin-right: 28px;
  }

  .chain-block {
    margin-bottom: 40px;
    .chain-box {
      width: 160px;
      height: 110px;
      border: 1px solid rgba(255, 255, 255, 0.2);
      border-radius: 12px;
      flex-direction: column;

      img {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        margin-bottom: 8px;
        border-radius: 8px;
      }
    }
  }
}
</style>
<style lang="scss">
.information-message-box {
  .box-loading {
    margin-top: 36px;
    margin-bottom: 32px;
  }

  .message-box-common .message-box-main .message-box-top {
    padding: 24px 24px 4px;
  }
  .message-box-common .message-box-main .message-box-content {
    padding: 40px 32px;

    p {
      line-height: 21px;

      &.text-invite-address {
        color: #a6f616;
      }
    }
  }
}
</style>
